/**
 * Groups a Norwegian organisation number as `924 567 891`, the way the design and the prototype
 * show it. The API sends the raw stored value, which is unformatted.
 *
 * Lives in the pod rather than in `libs/toolkit`: there is one consumer today. Promote it when a
 * second appears.
 */
export function formatOrganizationNumber(value: string): string {
  const digits = value.replace(/\s/g, '');

  // Only Norwegian nine-digit numbers get grouped. Anything else is returned verbatim — guessing a
  // grouping for a format we do not recognise mangles it, and showing it as stored does not.
  if (!/^\d{9}$/.test(digits)) return value;

  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}
